import type { ISubscriptionPlan } from '@src/quince-site-common/src/domains/Subscription'

import type { FrequencyOption } from './purchase-type-selector.types'

export function mapPlansToFrequencyOptions(plans: ISubscriptionPlan[]): FrequencyOption[] {
  return plans.map(plan => ({
    value: String(plan.planId),
    label: plan.frequency.displayLabel,
    isRecommended: plan.isDefault,
  }))
}

export function getDefaultPlanId(plans: ISubscriptionPlan[]): number | undefined {
  const defaultPlan = plans.find(plan => plan.isDefault)
  return defaultPlan?.planId ?? plans[0]?.planId
}

export function getPlanDetailsByPlanId(
  plans: ISubscriptionPlan[],
  planId: number | undefined,
): ISubscriptionPlan | undefined {
  if (!planId) return undefined
  return plans.find(p => p.planId === planId)
}
